import types from 'actions/types'
import {combineReducers} from "redux"

export const errorMessage = (state = null, action) => {
  switch (action.type) {
    case types.ACCOUNTING_SAGE50_PROVIDER_ENABLE_ATTEMPT:
      return null
    case types.ACCOUNTING_SAGE50_PROVIDER_ENABLE_FAILURE:
      return action.result
    default:
      return state
  }
}

export const provider = (state = null, action) => {
  switch (action.type) {
    case types.ACCOUNTING_SAGE50_PROVIDER_READ_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const isEnabling = (state = false, action) => {
  switch (action.type) {
    case types.ACCOUNTING_SAGE50_PROVIDER_ENABLE_ATTEMPT:
      return true
    case types.ACCOUNTING_SAGE50_PROVIDER_ENABLE_SUCCESS:
    case types.ACCOUNTING_SAGE50_PROVIDER_ENABLE_FAILURE:
      return false
    default:
      return state
  }
}

export default combineReducers({
  errorMessage,
  provider,
  isEnabling,
})
